import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Wrap,
  Panel,
  LogoWrap,
  Title,
  OrnDivider,
  Buttons,
  Btn,
  Note,
} from "./LandingPageStyles";
import Logo from "../../assets/images/Logo.png";
import { useExperience } from "../../context/ExperienceContext";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "../../components/LanguageSwitcher/LanguageSwitcher"; // 👈 ajustează calea
import SEO from "../../components/SEO/SEO";

const LandingPage = () => {
  const navigate = useNavigate();
  const { setExperience } = useExperience();
  const { t } = useTranslation();

  const handleSelect = (type) => {
    setExperience(type);
    if (type === "delivery") navigate("/meniu_delivery/");
    else navigate("/acasa");
  };

  return (
    <Wrap>
      <SEO
        title="La Fontanella Predeal | Pizza Predeal, Paste Predeal, Meniuri Predeal"
        description="Restaurant La Fontanella Predeal – gusturi autentice, livrare gratuită și preparate tradiționale."
      />
      <Panel role="dialog" aria-labelledby="landing-title">
        <LogoWrap>
          <img src={Logo} alt={t("landing.logoAlt")} />
        </LogoWrap>

        <Title id="landing-title">{t("landing.title")}</Title>

        <OrnDivider aria-hidden="true" />

        <Buttons>
          <Btn $variant="primary" onClick={() => handleSelect("delivery")}>
            {t("landing.deliveryButton")}
          </Btn>

          <Btn $variant="secondary" onClick={() => handleSelect("restaurant")}>
            {t("landing.restaurantButton")}
          </Btn>
        </Buttons>

        <Note>{t("landing.noteChangeAnytime")}</Note>
        <Note>{t("landing.noteRestaurantNoDelivery")}</Note>
      </Panel>

      {/* 👇 buton de limbă plutitor, vizibil și pe landing */}
      <LanguageSwitcher floating />
    </Wrap>
  );
};

export default LandingPage;
